import { useMemo } from "react";
import { MenuListItemType, MenuListItemVariant } from "@WahooFitness/redesignr";
import { getWorkoutTypeIcon } from "@/services/getWorkoutTypeIcon";
import { useWorkoutProfilesContext } from "@/hooks/useWorkoutProfilesContext";
import { WahooWorkoutTypeFamily } from "@WahooFitness/cloud-client-types";
import { ReactRouterLinkWrapper } from "../MenuList/ReactRouterLinkWrapper";

const useWorkoutProfiles = ({
  isNew = false,
  familyFilter,
  action,
}: {
  isNew?: boolean;
  familyFilter?: WahooWorkoutTypeFamily;
  action?: (profileId: string) => void;
}) => {
  const { workoutProfiles, workoutProfilesLoading, deleteProfile, mutateWorkoutProfiles } =
    useWorkoutProfilesContext();

  const workoutProfilesList: MenuListItemType[] = useMemo((): MenuListItemType[] => {
    return (
      workoutProfiles
        ?.filter((profile) => {
          return familyFilter !== undefined
            ? profile.workout_type_family_id === familyFilter
            : true;
        })
        .map((workoutProfile): MenuListItemType => {
          const WorkoutTypeIcon = getWorkoutTypeIcon(workoutProfile.workout_type_id);
          return {
            id: workoutProfile.external_id,
            icon: <WorkoutTypeIcon sx={{ width: "24px", height: "24px" }} />,
            content: workoutProfile.name,
            variant: MenuListItemVariant.CardLink,
            hasDivider: false,
            linkComponent: ReactRouterLinkWrapper,
            linkLocation: !isNew ? `/workout-profiles/${workoutProfile.external_id}` : undefined,
            action: () => action?.(workoutProfile.external_id),
          };
        }) || []
    );
  }, [action, familyFilter, isNew, workoutProfiles]);

  return {
    deleteProfile,
    workoutProfilesList,
    workoutProfilesLoading,
    mutateWorkoutProfiles,
  };
};

export default useWorkoutProfiles;
